import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'booleanYesNoTranslate',
  standalone: true
})
export class BooleanYesNoTranslate implements PipeTransform {
  translateService = inject(TranslateService);

  constructor() { }
  transform(value: boolean): string {
    return value ? this.translateService.instant('ml_143931') : this.translateService.instant('ml_143932');
  }
}
